import React, { useState, useMemo } from "react";
import {
  Drawer,
  Typography,
  Box,
  LinearProgress,
  IconButton,
  Divider,
  Button,
  Grid2,
} from "@mui/material";
import PrimaryIcon from "./PrimaryIcon";
import CloseIcon from "@mui/icons-material/Close";
import { ReactComponent as CoinIcon } from "Assets/Icons/Home/CoinIcon.svg";
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";
import LocalFireDepartmentIcon from "@mui/icons-material/LocalFireDepartment";
import SchoolIcon from "@mui/icons-material/School";
import EmojiObjectsIcon from "@mui/icons-material/EmojiObjects";
import MonetizationOnIcon from "@mui/icons-material/MonetizationOn";
import SupportIcon from "@mui/icons-material/Support";
import { useSelector } from "react-redux";

const styles = (theme) => ({
  padding: "20px",
  minWidth: "340px",
  overflow: "auto",
  "&::-webkit-scrollbar": {
    display: "none",
  },
  "& .primaryText": {
    color: theme.palette.primary.main,
  },
  "& .progress": {
    "&>p": {
      marginTop: "8px",
      fontSize: "16px",
      fontWeight: 500,
    },
  },
});

const AwardDrawer = ({ open, handleClose = () => {} }) => {

  const { Profile, CourseScore, Translation } = useSelector((state) => ({
    Profile: state.Profile.profile,
    CourseScore: state.Course.courseScore || {},
    Translation: state.Translation.translation?.Dashboard || {},
  }));

  const progress = useMemo(() => {
    return [
      { label: Translation?.Attendance, value: CourseScore?.AttendancePercentage },
      { label: Translation?.ProblemSolvingPercentage, value: CourseScore?.ProblemSolvedPercentage }
    ]
  }, [Translation, CourseScore]) 

  return (
    <Drawer anchor="right" open={open} onClose={handleClose}>
      <Grid2 sx={styles}>

        {/* Header */}
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Typography variant="h6">
            {Translation?.Hi} <strong>{Profile?.FullName}</strong>
          </Typography>
          <IconButton onClick={handleClose}>
            {" "}
            <PrimaryIcon height="12px" width="12px" icon={CloseIcon} cursor="pointer" />{" "}
          </IconButton>
        </Box>

        {/* <Box
          display={"flex"}
          alignItems={"start"}
          justifyContent={"space-between"}
          mb="30px"
        >
          <RenderLogo />
          <IconButton onClick={handleClose}>
            {" "}
            <PrimaryIcon height="15px" width="15px" icon={CloseIcon} />{" "}
          </IconButton>
        </Box> */}

        <Typography variant="body" color="textSecondary">
          {Translation?.GreatToSeeLearningProgress}
        </Typography>

        {/* <Typography variant="subtitle1" mt={2}>
          Attendance
        </Typography>
        <LinearProgress
          variant="determinate"
          value={10.3767}
          sx={{ height: 8, borderRadius: 5, backgroundColor: "#eee" }}
        />
        <Typography variant="body2">10.3767%</Typography>

        <Typography variant="subtitle1" mt={2}>
          Problem Solving Percentage
        </Typography>
        <LinearProgress
          variant="determinate"
          value={6.3}
          sx={{ height: 8, borderRadius: 5, backgroundColor: "#eee" }}
        />
        <Typography variant="body2">6.3%</Typography> */}

        {progress.map((item, index) => (
          <Box key={index} mt={2} className="progress">
            <Typography variant="subtitle1">{item.label}</Typography>
            <LinearProgress
              variant="determinate"
              value={item.value}
              sx={{ height: 8, borderRadius: 5, backgroundColor: "#eee" }}
            />
            <Typography variant="body2">{item.value}%</Typography>
          </Box>
        ))}

        <Divider sx={{ my: 2 }} />

        {/* Stats */}
        <Box display="flex" justifyContent="space-between">
          <Box textAlign="center">
            <LocalFireDepartmentIcon color="error" />
            <Typography variant="title" fontWeight={700} fontSize="16px">{Translation?.BestStreak}</Typography>
            <Typography variant="h6">7</Typography>
          </Box>
          <Box textAlign="center">
            <LocalFireDepartmentIcon color="warning" />
            <Typography variant="title" fontWeight={700} fontSize="16px">{Translation?.CurrentStreak}</Typography>
            <Typography variant="h6">0</Typography>
          </Box>
        </Box>

        <Box display="flex" justifyContent="space-between" mt={2}>
          <Box textAlign="center">
            <EmojiObjectsIcon color="primary" />
            <Typography variant="title" fontWeight={700} fontSize="16px">{Translation?.ProblemsSolved}</Typography>
            <Typography variant="h6">{CourseScore?.ProblemSolved}</Typography>
          </Box>
          <Box textAlign="center" gap="8px">
            <SchoolIcon color="primary" />
            <Typography variant="title" fontWeight={700} fontSize="16px">{Translation?.ClassesAttended}</Typography>
            <Typography variant="h6">{CourseScore?.Attendance}</Typography>
          </Box>
        </Box>

        <Box textAlign="center">
          <MonetizationOnIcon color="secondary" />
          <Typography variant="subtitle2">{Translation?.Coins}</Typography>
          <Typography variant="h6">237</Typography>
        </Box>

        {/* <Box display="flex" flexDirection={"column"} justifyContent="center" gap="8px" mt={2}>
          <PrimaryIcon height="16px" width="16px" icon={CoinIcon} />
          <Typography variant="subtitle2">{Translation?.Coins}</Typography>
          <Typography variant="h6">237</Typography>
        </Box> */}

        <Divider sx={{ my: 2 }} />

        {/* Support Button */}
        <Box display="flex" justifyContent="center">
          <Button
            variant="contained"
            color="primary"
            startIcon={<SupportIcon />}
          >
            {Translation?.Support}
          </Button>
        </Box>
      </Grid2>
    </Drawer>
  );
};

export default AwardDrawer;
